import { useContext } from 'react'

import { isNil } from 'ramda'

import { createSharedContext } from '@twistopayments/design-system/utils'

export type API = {
  variant: 'head' | 'body'
}

const TableSectionContext = createSharedContext<null | API>('components/atoms/table/table-section.context#0', null)

const TableSectionProvider = TableSectionContext.Provider

const variantToComponentRootMap = {
  head: 'th',
  body: 'td',
} as const

type HookProps = {
  component?: (typeof variantToComponentRootMap)[keyof typeof variantToComponentRootMap]
}

const useTableSection = ({ component }: HookProps) => {
  const context = useContext(TableSectionContext)

  if (isNil(context)) {
    throw new Error(`useTableSection must be used within a CountProvider`)
  }

  const Component = component ?? variantToComponentRootMap[context.variant]

  return {
    context,
    Component,
  }
}

export { useTableSection, TableSectionProvider }
